// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1dLfz","paramInput":"JobSimulator_paramInput__3038V","input":"JobSimulator_input__1kCip"};